import type { ApplicantCard } from '../../../hooks/use-opportunity-applicants'
import type { JobProspectMatch } from '../../../hooks/use-job-prospect-matches'

export type CandidatePanelApplicantSource = {
  kind: 'applicant'
  applicant: ApplicantCard
  rank?: number
}

export type CandidatePanelProspectSource = {
  kind: 'prospect'
  match: JobProspectMatch
}

export type CandidatePanelSource = CandidatePanelApplicantSource | CandidatePanelProspectSource

export type CandidateCommitment = 'applied' | 'invited' | 'prospect'

export function resolveCandidateCommitment(source: CandidatePanelSource): CandidateCommitment {
  if (source.kind === 'prospect') return 'prospect'
  return source.applicant.status === 'invited' ? 'invited' : 'applied'
}

export function isCandidateTerminal(source: CandidatePanelSource): boolean {
  if (source.kind === 'prospect') return false
  const applicant = source.applicant
  if (applicant.current_stage?.is_terminal) return true
  return applicant.status === 'hired' || applicant.status === 'rejected' || applicant.status === 'withdrawn'
}

export function isCandidateInterviewStage(source: CandidatePanelSource): boolean {
  if (source.kind !== 'applicant') return false
  const applicant = source.applicant
  return applicant.status === 'interview' || applicant.current_stage?.slug === 'interview'
}

export function isCandidateActiveApplicant(source: CandidatePanelSource): boolean {
  if (source.kind !== 'applicant') return false
  return source.applicant.status !== 'invited' && !isCandidateTerminal(source)
}
